import React, { useState } from 'react';
import {
  Container,
  FormContent,
  FormField,
  Title,
  FormGroup, 
  Label,
  Input, 
  RetirementCard,
  CheckboxContainer,
  CheckboxLabel,
  Checkbox,
  ButtonContainer,
  BtnClose,
  BtnCancel,
  BtnRetire
} from './styles';

const FormRetirements = ({ _credit_name, _balance, onClose, onSubmit }) => {
  const [form, setForm] = useState({
    credit_name: _credit_name || '',
    quantity: '',
    beneficiary: '',
    purpose: '',
    wilder_user: '',
    password: '',
    pin: '',
    confirmation: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newFormData = {
      ...form,
      [name]: type === 'checkbox' ? checked : value
    };

    setForm(newFormData);
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(form);
    }
  };

  return (
    <Container>
      <FormContent>
        <BtnClose onClick={onClose}>✖</BtnClose>
        <Title>Solicitar Aposentadoria</Title>
        <FormGroup>
          {[
            { label: 'Projeto', name: 'credit_name', type: 'text', disabled: true },
            { label: 'Quantidade para aposentar', name: 'quantity', type: 'number' },
            { label: 'Beneficiário', name: 'beneficiary', type: 'text' },
            { label: 'Finalidade', name: 'purpose', type: 'text' },
            { label: 'Email Wilder', name: 'wilder_user', type: 'text' },
            { label: 'Senha', name: 'password', type: 'password' },
            { label: 'Pin', name: 'pin', type: 'password' }
          ].map(({ label, name, type, disabled }) => (
            <FormField key={name}>
              <Label htmlFor={name}>{label}:</Label>
              <Input
                type={type}
                id={name}
                name={name}
                value={form[name]}
                onChange={handleChange}
                disabled={disabled}
                placeholder={disabled ? '' : `Digite ${label.toLowerCase()}`}
              />
            </FormField>
          ))}

          <RetirementCard>
            <CheckboxContainer>
              <Checkbox
                type="checkbox"
                id="confirmation"
                name="confirmation"
                checked={form.confirmation}
                onChange={handleChange}
              />
              <CheckboxLabel htmlFor="confirmation">
                Confirmo que desejo aposentar esses créditos
              </CheckboxLabel>
            </CheckboxContainer>
          </RetirementCard>

          <ButtonContainer>
            <BtnCancel onClick={onClose}>
              Cancelar
            </BtnCancel>

            <BtnRetire
              primary
              type="button"
              onClick={handleSubmit}
            >
              Aposentar
            </BtnRetire>
          </ButtonContainer>
        </FormGroup>
      </FormContent>
    </Container>
  );
};

export default FormRetirements;